// extracted by mini-css-extract-plugin
export var measureBox = "_b8-0";